import React from "react";

const NoteDisplay = ({ text, pos, isAdminPage, isTiny, count, company }) => {
  if (!text) {
    return <></>;
  }
  const textArr = text.split(":");
  if (textArr.length <= 1) {
    return <div>{text}</div>;
  } else {
    const tag = textArr[0].trim();
    let desc;

    if (isAdminPage) {
      desc = textArr.slice(1).join(":");
    } else {
      desc = textArr.pop().trim();
    }
    if (desc === '"' || desc === "") {
      desc = `${textArr.pop()}`;
    }
    if (isTiny) {
      return (
        <div>
          {count && <span className="mr2">{count}.</span>}
          {desc}
        </div>
      );
    }
    return (
      <div className="note-tag-container flex">
        <div className="note-tag-tag f7">
          {company ? (
            <a
              href={`https://dowhatworks.io/home/${company}/report?tag=${tag}`}
              className="ui-link-underline"
            >
              {tag}
            </a>
          ) : (
            <>{tag}</>
          )}
        </div>
        <div className="note-tag-desc">{desc}</div>
      </div>
    );
  }
};

export default NoteDisplay;
